export function formatEuro(value) {
  return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(value)
}

export function formatEuroAmount(value) {
  return new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(value)
}

export function formatRate(value) {
  return `${new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 2 }).format(value)} %`
}

export function parseEuro(value) {
  const amount = Number.parseFloat(
    String(value ?? '')
      .replace(/[^\d,.-]/g, '')
      .replace(',', '.')
  )

  return Number.isFinite(amount) ? amount : 0
}
